import { FieldLabel } from '../../shared/ui/field-label';
import { Hint } from '../../shared/ui/hint';
import { Input } from '../../shared/ui/input';
import { MutationError } from '../../shared/ui/mutation-error';
import { Note } from '../../shared/ui/note';
import { SectionPanel } from '../../shared/ui/section-panel';
import type { TOrganizationProfile } from './use-organization-profile';

export const OrganizationProfile = ({
  profile,
  editable,
}: {
  profile: TOrganizationProfile;
  editable: boolean;
}) => {
  const { draft, change } = profile;

  return (
    <SectionPanel
      title="Name and address"
      note={
        editable ? 'owners and admins can change these' : 'only owners and admins can change these'
      }
    >
      <div className="grid grid-cols-2 gap-5 px-card py-4">
        <div>
          <FieldLabel htmlFor="org-name">Organization name</FieldLabel>
          <Input
            id="org-name"
            value={draft.name}
            disabled={!editable}
            invalid={editable && !profile.nameOk}
            onChange={(event) => change({ name: event.target.value })}
          />
          <Hint>What everyone sees in the organization switcher and in emails.</Hint>
        </div>
        <div>
          <FieldLabel htmlFor="org-slug">Address</FieldLabel>
          <Input
            id="org-slug"
            mono
            value={draft.slug}
            disabled={!editable}
            invalid={editable && !profile.slugOk}
            onChange={(event) => change({ slug: event.target.value })}
          />
          <Hint>
            Part of every webhook address you hand out. If you change it, the old addresses keep
            working for 30 days and forward to the new ones.
          </Hint>
        </div>
      </div>

      {(profile.save.isError || (editable && !profile.slugOk) || profile.moved) && (
        <div className="flex flex-col gap-3 px-card pb-4">
          {profile.save.isError && <MutationError error={profile.save.error} />}
          {editable && !profile.slugOk && (
            <Note tone="danger">
              Use at least three lowercase letters, digits or single hyphens, starting and ending
              with a letter or digit.
            </Note>
          )}
          {profile.moved && <Note tone="caution">{profile.moved.warning}</Note>}
        </div>
      )}
    </SectionPanel>
  );
};
